import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          <Reveal>
            <div className="lg:sticky lg:top-28">
              <p className="mb-3 flex items-center gap-2 text-xs font-label font-medium uppercase tracking-[0.28em] text-primary-600">
                <span className="h-px w-6 bg-primary-500" />
                常见问题
              </p>
              <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
                投稿前，你可能想先知道这些
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                关于匿名、核实与撤回，我们把最常被问到的问题整理在这里。如果还有疑问，可以直接发邮件问编辑。
              </p>
              <a
                href="#contact"
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-5 py-3 text-sm font-medium text-secondary-800 transition-colors hover:bg-secondary-50"
              >
                <i className="ri-mail-line" aria-hidden="true" />
                还有其他疑问
              </a>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <ul className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqs.map((item, index) => {
                const isOpen = index === openIndex;
                return (
                  <li key={item.question}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => toggle(index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-7"
                      >
                        <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                          {item.question}
                        </span>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-lg transition-colors ${
                            isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
                        </span>
                      </button>
                    </h3>
                    <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-60" : "max-h-0"}`}>
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-7">
                        {item.answer}
                      </p>
                    </div>
                  </li>
                );
              })}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}